
import { defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default defineComponent({
  setup() {
    const username = ref();
    const password = ref();
    const store = useStore();
    const router = useRouter();

    const login = () =>
        store
            .dispatch('login', { username: username.value, password: password.value })
            .then(() => {
              store.dispatch('addNotification', { type: 'sucess', message: 'Willkommen!' });
              router.push({ name: 'Index' });
            })
            .catch(() => {
              store.dispatch('addNotification', { type: 'error', message: 'Falscher Username oder Passwort' });
            });

    return {
      username,
      password,
      login,
    };
  },
});
